<template>
  <nav>
    <div class="nav">
      <div class="logo">
        <img alt="logo" :src="logo" />
      </div>
      <div class="nav-pills">
        <div class="menu-item">
          <a @click="goHome" href="#">首页</a>
          <div :class="getPageStatusOne()"></div>
        </div>
        <div class="menu-item">
          <el-dropdown>
            <a @click="goProductCenter" href="#">产品中心</a>
            <div :class="getPageStatusTwo()"></div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a @click="goMedical" href="#">智慧医疗</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a @click="goOperaing" href="#">智慧运营管理</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a @click="goService" href="#">智慧服务</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a @click="goInter" href="#">智慧互联</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <a  @click="goProductCenter" href="#">产品中心</a> -->
        </div>
        <div class="menu-item">
          <a @click="goSupandSer" href="#">支持与服务</a>
          <div :class="getPageStatusThree()"></div>
        </div>
        <div class="menu-item">
          <a @click="goRecruiment" href="#">招贤纳士</a>
          <div :class="getPageStatusFour()"></div>
        </div>
        <div class="menu-item">
          <a @click="goAboutUs" href="#">关于我们</a>
          <div :class="getPageStatusFive()"></div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import logo from "../../src/assets/logo.png";
export default {
  name: "navbar",
  data() {
    return {
      logo: logo,
    };
  },
  mounted(){
    this.getPageStatusFive()
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
    },
    goProductCenter() {
      this.$router.push({ path: "productCenter" });
    },
    goAboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
    goSupandSer() {
      this.$router.push({ path: "SupandSer" });
    },
    goRecruiment() {
      this.$router.push({ path: "recruiment" });
    },
    goMedical() {
      this.$router.push({ path: "medical" });
    },
    goService() {
      this.$router.push({ path: "service" });
    },
    goOperaing() {
      this.$router.push({ path: "operaing" });
    },
    goInter() {
      this.$router.push({ path: "inter" });
    },
    getPageStatusOne() {
      return this.$route.path === "/" ? "chooseLine" : "unChooseLine";
    },
    getPageStatusTwo() {
      return this.$route.path === "/productCenter" ? "chooseLine" : "unChooseLine";
    },
    getPageStatusThree() {
      return this.$route.path === "/SupandSer" ? "chooseLine" : "unChooseLine";
    },
    getPageStatusFour() {
      return this.$route.path === "/recruiment" ? "chooseLine" : "unChooseLine";
    },
    getPageStatusFive() {
      console.log(this.$route.path)
      return this.$route.path === "/aboutUs" ? "chooseLine" : "unChooseLine";
    },
  },
};
</script>

<style>
.nav {
  display: flex;
  width: 85%;
  margin: 0 auto;
  height: 80px;
}
.nav-pills {
  /* text-align: right; */
  justify-content: space-around;
  display: flex;
  width: 60%;
  margin-top: 29px;
}
.logo {
  width: 40%;
  margin-top: 17px;
}
.nav .menu-item.active,
nav .menu-item:hover {
  border-bottom: 4px solid #e52f22;
  height: 33px;
}
.menu-item {
  border-bottom: 4px solid #ffffff;
  height: 33px;
}
.nav-pills a {
  font-size: 18px;
  color: #74798e;
  letter-spacing: 0;
  text-align: right;
  font-weight: 400;
  text-decoration: none;
}
.nav-pills a:hover {
  text-decoration: none;
  font-size: 18px;
  color: #e52f22;
  letter-spacing: 0;
  text-align: right;
  font-weight: 500;
}
.el-dropdown-menu__item a {
  font-size: 16px;
  color: #767b8d;
  letter-spacing: 0;
  /* background-color: pink; */
  cursor: pointer;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
}
.el-dropdown-menu__item a.active,
.el-dropdown-menu__item a:hover {
  font-size: 16px;
  color: #e52f22;
  letter-spacing: 0;
  font-weight: 400;
  text-align: center;
}
/* .el-dropdown-item {

} */

.chooseLine {
  background: #e52f22;
  width: 100%;
  height: 4px;
  margin-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/layout/Navbar.vue